import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import toast from 'react-hot-toast';

interface StripeCardFormProps {
  orderId: string;
  totalLabel: string;
  onSuccess: () => void;
}

const StripeCardForm: React.FC<StripeCardFormProps> = ({ orderId, totalLabel, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePay = async () => {
    if (!stripe || !elements) return;

    setIsProcessing(true);
    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/orders/${orderId}`,
        },
        redirect: 'if_required',
      });

      if (error) {
        toast.error(error.message || 'Payment failed');
      } else if (paymentIntent && paymentIntent.status === 'succeeded') {
        toast.success('Payment successful');
        onSuccess();
      } else if (paymentIntent && paymentIntent.status === 'requires_action') {
        // Stripe will have already redirected for 3D Secure if needed
      } else {
        toast.error('Payment could not be completed');
      }
    } catch {
      toast.error('Payment failed');
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="mt-4 p-4 border border-light bg-white">
      <PaymentElement />
      <button
        onClick={handlePay}
        disabled={!stripe || isProcessing}
        className="btn-primary w-full mt-4 disabled:opacity-50"
      >
        {isProcessing ? 'Processing...' : `Pay ${totalLabel}`}
      </button>
    </div>
  );
};

export default StripeCardForm;